import Collapse from "@mui/material/Collapse";
import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import PrintOptionAttributeComments from "./PrintOptionAttributeComments";
import PrintOptionAutoScale from "./PrintOptionAutoScale";
import PrintOptionDynamicColumnWidths from "./PrintOptionDynamicColumnWidths";
import PrintOptionFontScale from "./PrintOptionFontScale";
import PrintOptionFrozenColumnsForEachPage from "./PrintOptionFrozenColumnsForEachPage";
import PrintOptionPageHeader from "./PrintOptionPageHeader";
import PrintOptionPaperSizeAndOrientation from "./PrintOptionPaperSizeAndOrientation";
import TableCustomViewOptionsStore from "./TableCustomViewOptionsStore";

const TablePrintOptions: FunctionComponent = observer(function TablePrintOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		hasPrintOptions,
		printOptionsCollapse,
		toggleCollapsedPrintOptions,
	} = optionsStore as TableCustomViewOptionsStore;

	if (!hasPrintOptions) {
		return;
	}

	return (
		<CustomViewOptionCustomSection
			collapsed={printOptionsCollapse}
			dataCsiAutomation="TablePrintOptions"
			onCollapse={toggleCollapsedPrintOptions}
			titleRes="CustomViewPrintOptions"
		>
			<Collapse in={!printOptionsCollapse} timeout="auto">
				<PrintOptionPaperSizeAndOrientation />
				<PrintOptionPageHeader />
				<PrintOptionAttributeComments />
				<PrintOptionDynamicColumnWidths />
				<PrintOptionFrozenColumnsForEachPage />
				<PrintOptionAutoScale />
				<PrintOptionFontScale />
			</Collapse>
		</CustomViewOptionCustomSection>
	);
});

export default TablePrintOptions;